module.exports = __webpack_public_path__ + "static/img/okrengou.ff1064d2.png";